function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.608 -0.061)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M188.643,107.822A76.822,76.822,0,1,1,111.822,31,76.822,76.822,0,0,1,188.643,107.822Z",
  transform: "translate(189.131 167.484)",
  fill: "#4f1e66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.214,50.807A25.607,25.607,0,1,1,89.607,25.2,25.608,25.608,0,0,1,115.214,50.807Z",
  transform: "translate(345.783 136.153)",
  fill: "#4f1e66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.214,96.807A25.607,25.607,0,1,1,45.607,71.2,25.608,25.608,0,0,1,71.214,96.807Z",
  transform: "translate(108.104 384.637)",
  fill: "#4f1e66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513.8,76.977C492.674,37.926,445.94,16.8,383.2,16.8c-60.177,0-128.676,19.205-193.335,55.056-138.279,74.9-213.18,195.9-170.288,274.637,10.243,17.285,24.967,32.009,42.892,40.971.64-8.962,3.2-17.285,8.322-24.327A71.714,71.714,0,0,1,42.627,334.33C7.417,270.311,81.038,160.2,203.312,93.622c60.817-33.289,125.475-51.855,181.171-51.855,53.135,0,91.546,16.645,108.19,46.733s9.6,71.7-18.565,115.873c-30.088,46.733-80.663,90.906-141.48,124.835C276.293,359.937,217.4,377.862,164.9,380.423a49.753,49.753,0,0,1,1.28,10.243c0,5.121-1.28,10.243-2.561,15.364,56.976-2.561,120.994-21.126,181.811-54.415,64.658-35.21,118.433-82.583,151.083-133.158C527.884,165.962,534.926,115.388,513.8,76.977Z",
  transform: "translate(40.664 90.778)",
  fill: "#4f1e66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.491,35.3a52.339,52.339,0,0,1-23.047,11.523c10.243,37.771-32.649,96.667-100.508,133.8-37.13,20.486-76.181,31.369-109.471,31.369-31.369,0-53.135-9.6-62.738-26.888-8.963-16-5.762-37.771,8.322-61.457a117.4,117.4,0,0,1,1.28-44.813,195.1,195.1,0,0,0-19.846,25.607c-21.766,34.57-26.247,67.219-12.163,92.826s44.172,39.691,85.144,39.691c37.771,0,81.3-12.163,121.634-34.57C320.324,157.575,367.057,85.874,348.491,35.3Z",
  transform: "translate(120.188 190.712)",
  fill: "#4f1e66"
}));

function SvgGalaxia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 614,
    height: 614,
    viewBox: "0 0 614 614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxia);
export default __webpack_public_path__ + "static/media/galaxia.3896d9a2.svg";
export { ForwardRef as ReactComponent };